/*
const issues = {
    issues: [],
};
*/

const issues = [];

export default issues;